import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import AgentShareLinkTab from "@/components/agent/tabs/publish/AgentShareLinkTab";
import AgentChatBubbleTab from "@/components/agent/tabs/publish/AgentChatBubbleTab";
import { useAuth } from "@/contexts/AuthContext";

interface AgentPublishModalProps {
  isOpen: boolean;
  onClose: () => void;
  agent: any;
  updateAgent: (data: Partial<any>) => Promise<boolean>;
}

const AgentPublishModal: React.FC<AgentPublishModalProps> = ({
  isOpen,
  onClose,
  agent,
  updateAgent,
}) => {
  const [activeTab, setActiveTab] = useState("link");
  const { organization } = useAuth();

  // Only show content if agent is active
  if (!agent?.is_active) {
    return (
      <Dialog open={isOpen} onOpenChange={onClose}>
        <DialogContent className="w-[600px] max-w-[90vw]">
          <DialogHeader>
            <DialogTitle>Share your agent</DialogTitle>
          </DialogHeader>
          <div className="mt-4 text-center py-8">
            <p className="text-muted-foreground mb-4">
              Your agent needs to be activated before it can be shared.
            </p>
            <p className="text-sm text-muted-foreground">
              Please activate your agent first to enable sharing options.
            </p>
          </div>
        </DialogContent>
      </Dialog>
    );
  }

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="w-[600px] max-w-[90vw] max-h-[90vh] overflow-y-auto overflow-x-hidden">
        <DialogHeader>
          <DialogTitle>Share your agent</DialogTitle>
        </DialogHeader>
        <div className="mt-6">
          <Tabs value={activeTab} onValueChange={setActiveTab}>
            <TabsList className="flex w-full">
              <TabsTrigger value="link" className="flex-1">
                With a link
              </TabsTrigger>
              <TabsTrigger value="website" className="flex-1">
                On your website
              </TabsTrigger>
            </TabsList>

            <TabsContent value="link" className="mt-6">
              <AgentShareLinkTab
                agentPublicId={agent.public_id}
                agentUrl={organization?.agent_url}
              />
            </TabsContent>

            <TabsContent value="website" className="mt-6">
              <AgentChatBubbleTab agent={agent} updateAgent={updateAgent} />
            </TabsContent>
          </Tabs>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default AgentPublishModal;
